import omit from "lodash/omit";
import { Activity } from "PFCore/types";
import { PropsWithChildren, useRef, useState } from "react";
import { createStore } from "zustand";

import { MultiActivityFormStoreType } from "./multi_activity_form_store.types";
import { MultiActivityFormStoreContext } from "./multi_activity_form_store_context";

type MultiActivityFormStoreProviderProps = PropsWithChildren<{ parentActivity?: Activity }>;

export const MultiActivityFormStoreProvider = ({
  parentActivity,
  children
}: MultiActivityFormStoreProviderProps) => {
  const scrollableContainerRef = useRef<HTMLDivElement>(null);

  const [store] = useState(
    createStore<MultiActivityFormStoreType>()((set) => ({
      scrollableContainerRef,
      parentActivity,
      availabilitySidePanelRoleFormKey: null,
      roles: {},
      actions: {
        setRoleData: (uniqueId, data = { activityCreator: null, attachments: [] }) =>
          set((state) => ({
            roles: {
              ...state.roles,
              [uniqueId]: {
                ...state.roles[uniqueId],
                ...data
              }
            }
          })),
        clearRoleData: (uniqueId) =>
          set((state) => ({
            roles: omit(state.roles, uniqueId)
          })),
        setAvailabilitySidePanelRoleFormKey: (roleFormKey) =>
          set({ availabilitySidePanelRoleFormKey: roleFormKey })
      }
    }))
  );

  return (
    <MultiActivityFormStoreContext.Provider value={store}>{children}</MultiActivityFormStoreContext.Provider>
  );
};
